export default __webpack_public_path__ + "static/media/tokenBg.7b9eab3b.png";